import React from "react";
import { Grid, Box, Typography, Chip , Container } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import OrgChart from "./TeamComponent/OrgChart";

const values = [
  { label: "Gratitude", color: "#9cd37b" },
  { label: "Forgiveness", color: "#86cdbe" },
  { label: "Love", color: "#9cd37b" },
  { label: "Humility", color: "#86cdbe" },
  { label: "Giving", color: "#9cd37b" },
  { label: "Patience", color: "#86cdbe" },
  { label: "Truth", color: "#9cd37b" },
];

const Team = () => {
  return (
    <>

      {/* Home Team section */}
      <Box
              className="teamSectionBg commonBannerBg"
              sx={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                // position: "relative",
                color: "white",
                px: 2,
              }}
            >
              {/* Mini Header (Top-Left) */}
              <Box
                sx={{
                  position: "absolute",
                  top: 80,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
              </Box>
      </Box>

      {/* Team Founder Section Start*/}
      <Box className="founder-card mb-50px" mb={5}>

         {/* message section */}

         
      {/* <Box>
        <Grid container>
         <Grid size={12}>
              <Typography variant="h6" className="message-title">
                Message:
              </Typography>
              <Typography className="message-text">
                Together - we can, we will.
              </Typography>
            </Grid>
        </Grid>    
      </Box> */}

        {/* huzafia profile section */}
        <Box className="" mt={5}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading">
                Founder
              </Typography>
            </Grid>
            <Grid size={12} className="profileBgWave">
              <img
                src={imgUrl.huzafirProfile}
                className="w-100 founder-avatar"
              ></img>
            </Grid>
          </Grid>
        </Box>

        {/* huzafia movement profile section */}
        <Box
          sx={{
            position: "relative",
            px: 1,
            py: 0,
            pb:4,
            textAlign: "center",
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              opacity: 0.2,
              zIndex: 0,
            }}
            className="peaceSectionBg"
          />

          {/* Text Content */}
          <Box
            sx={{
              fontWeight: 400,
              color: "black",
              position: "relative",
              zIndex: 1,
              maxWidth: 800,
              margin: "0 auto",
              lineHeight: 1.6,
              fontSize: "40px",
            }}
          >
            <div className="founderBg">
              <Box>
                <Typography variant="h6" className="founder-name">
                  Dr. Huzaifa Khorakiwala
                </Typography>

                <Box className="founder-roles">
                <i>
                  <Typography><i>Executive Director, Wockhardt</i></Typography>
                  <Typography>Owner, Jupiter Events LLC</Typography>
                  <Typography>Founder, I Am Peacekeeper Movement</Typography>
                  <Typography>CEO, Wockhardt Foundation</Typography>
                  <Typography>Chairman, Global Justice, Love & Peace Summit</Typography>
                  <Typography>Chairman, Billionaires for Peace</Typography>
                  {/* <Typography>Health Advisor, PM Guinea Bissau</Typography> */}
                  </i>
                </Box>
              </Box>
            </div>
          </Box>
        </Box>

        {/* message section */}
        <Box mb={0} className="" sx={{marginBottom:'10px'}}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              className="d-flex-align-center-justify-center flex-direction-column w-100"
            >
              <Typography variant="h6" className="subHeading">
                Guided by values of:
              </Typography>

              <Grid container spacing={1} justifyContent="center">
                {values.slice(0, 4).map((val) => (
                  <Grid item key={val.label}>
                    <Chip
                      label={val.label}
                      style={{ backgroundColor: val.color }}
                      className="value-chip"
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid
                container
                spacing={1}
                justifyContent="center"
                sx={{ mt: 1 }}
              >
                {values.slice(4).map((val) => (
                  <Grid item key={val.label}>
                    <Chip
                      label={val.label}
                      style={{ backgroundColor: val.color }}
                      className="value-chip"
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

           
          </Grid>
        </Box>

        <Box className="mt-50px" mt={5} pt={3}>


          <Container>
          <Typography variant="h5" className="founder-title mainHeading">
                I Am Peacekeeper Organisation Structure
              </Typography>
           {/* <Typography variant="h6" className="subHeading" mb={0} style={{marginBottom:"0px"}}>
               The I Am Peacekeeper Movement International Structure
              </Typography> */}
                  {/* <img src={imgUrl.teamChart} className="w-100"></img> */}
                  <OrgChart/>
                  <Box align="center" display="flex" direction="column" flexDirection="column">
                    <Typography fontWeight="800">The I Am Peacekeeper Movement International Structure</Typography>
                    <Typography>Works on a matrix structure. Individual Programme Initiatives’ Managers in each country report to their respective I Am <br></br>
Peacekeeper Country Directors and to the individual I Am Peacekeeper International Programme Heads</Typography>
                  </Box>
          </Container>
          
        </Box>
        {/* advisor section */}
        <Box className="d-none" mt={5}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading">
                Advisor
              </Typography>
            </Grid>
            
          </Grid>
        </Box>

        {/* directors section  */}
        <Box className="d-none" mt={5}>
          <Grid container direction="column" align="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading">
                Directors
              </Typography>
            </Grid>

          </Grid>
        </Box>
        {/* Team section  */}
        <Box className="d-none" mt={5}>
          <Grid container direction="column" align="center" spacing={2}>
            <Grid size={12}>
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h5" className="founder-title mainHeading">
                Team
              </Typography>
            </Grid>
          
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Team;
